import {useState, useEffect} from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import {compose} from '../../lib/compose';
import { usePortalContext } from '../../lib/context/portalContext';
import withAlerts from '../../lib/withAlerts';
import { useCustomerAdminRoleMutations } from './adminMutations'
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import {useForm} from 'react-hook-form';
import {PropTypes} from 'prop-types';
import {getClaims} from '../auth/sessionStore';
import {useCustomerContext} from '../../lib/context/customerContext';

const AdminDetails = (props) => {
  const {togglePortal, rowData} = usePortalContext();
  const {assign, unassign} = useCustomerAdminRoleMutations();
  const {data} = useQuery(ROLES);
  const [buttontext, setButtontext] = useState('Assign Role');
  const {register, handleSubmit, setValue} = useForm();
  const {alerts} = props;
  const {success, error} = alerts;
  const {hasPermission} = useCustomerContext();
  const roles = data?.Roles?.result || [];
  const {id: admin_id, username} = rowData?.customer_admin ?? '';
  const role_name = rowData?.role_names[0] ?? '';

  const existingRole = roles.find(role => role.name === role_name) || 'select_role';

  useEffect(() => {
    if (existingRole?.id) {
      setValue('role', existingRole.id);
    }
  }, [existingRole, setValue]);

  // get current username
  const {preferred_username: current_username} = getClaims();
  const roleAssignmentDisabled = (username === current_username) || !hasPermission('CA_ROLE_ASSIGNMENT');
  
  const handleRoleUnassign = async (role_input) => {
    const unassignRole = await unassign({variables: {role_input: role_input}});
    return unassignRole;
  }

  const handleRoleAssign = async (role_input) => {
    const assignRole = await assign({variables: {role_input: role_input}});
    return assignRole;
  }

  const handleRoleChange = async (formData) => {
    const role_id = formData?.role;
    let handler, subHandler;

    switch(role_id) {
      case 'select_role':
        return null;

      case undefined:
        return null;

      case 'unassign':
        if(existingRole?.id) {
          handler = await handleRoleUnassign({
            id: existingRole.id,
            admin_id: admin_id,
            username: username
          });
        }
        break;
      
      default:
        if(existingRole?.id) {
          subHandler = await handleRoleUnassign({
            id: existingRole.id,
            admin_id: admin_id,
            username: username
          });
        }

        handler = await handleRoleAssign({
          id: role_id,
          admin_id: admin_id,
          username: username
        })
        break;
    }

    if(handler?.errors || subHandler?.errors) {
      const userFacingError = ('Administrator role assignment failed.');
      console.error(userFacingError + JSON.stringify(handler?.errors));
      error({msg: userFacingError});  
    } else {
      success({msg: `Administrator role assignment completed.`});
      togglePortal();
    }
  }

  const handleRoleSelect = (val) => {
    if(val == 'unassign') {
      setButtontext("Unassign Role");
    } else {
      setButtontext("Assign Role");
    }
  }


  return (
    <div className="offcanvas-form">
      <Form className="mb-3" onSubmit={handleSubmit(handleRoleChange)}>
        <Form.Group className="mb-3">
          <Form.Label>Administrator ID</Form.Label>
          <Form.Control type="text" value={username} readOnly={true} disabled/>
        </Form.Group>
        

        <Form.Group className="mb-3">
          <Form.Label>Role</Form.Label>
            <Form.Select
              disabled={roleAssignmentDisabled}
              {...register('role',{
                onChange: (e) => handleRoleSelect(e.target.value)
              })}
            >
              <option key="select_role" value="select_role">Select Role</option>
              {roles?.map(({id, name}) => (
                <option key={id} value={id}>{name}</option>
              ))}
              <option key="unassignrole" value="unassign">Unassign role</option>
            </Form.Select>
          </Form.Group>

          <Row>
          <Col className="mb-3">
            <div className="d-grid gap-2">
              <Button type="submit" disabled={roleAssignmentDisabled}>{buttontext}</Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

const ROLES = gql`
  query getRoles {
    Roles {
      result {
        id
        type
        name
        description        
      }
      metadata {
        page {
          num
          len
          total
          inPage
          records
        }
      }
    }
  }
`;

AdminDetails.propTypes = {
  alerts: PropTypes.shape({
    success: PropTypes.func,
    error: PropTypes.func
  })
}

//export default AdminDetails
export default compose(
  withAlerts
)(AdminDetails);
